import { useFormikContext } from "formik";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { ContactUpdateFormValue, ContactUpdateFormValues } from "./contactUpdateTypes";

const HeaderAction = styled.div`
	display: flex;
	justify-content: space-between;
	color: ${({ theme }) => theme.colors.palette.grey[70]};
`;

const StyledHeaderButton = styled.button`
	background: none;
	color: inherit;
	font: inherit;
	outline: none;
	font-size: ${({ theme }) => theme.fonts.sizes.small};
	text-decoration: underline;
	cursor: pointer;

	&:hover {
		color: ${({ theme }) => theme.colors.palette.content.main.contrast};
	}
`;

interface Props {
	title: string;
	selectedSide: ContactUpdateFormValue;
}

export const ContactUpdateColumnHeader: FC<Props> = ({ title, selectedSide }) => {
	const { t } = useTranslation();
	const { values, setValues } = useFormikContext<ContactUpdateFormValues>();

	const handleClick = () => {
		void setValues(
			Object.keys(values).reduce(
				(formValues, categoryKey) => {
					const category = (formValues as any)[categoryKey];
					(formValues as any)[categoryKey] = Object.keys(category).reduce((record, key) => {
						return {
							...record,
							[key]: selectedSide,
						};
					}, category);
					return formValues;
				},
				{ ...values },
			),
		);
	};

	return (
		<HeaderAction>
			{title}
			<StyledHeaderButton type="button" onClick={handleClick}>
				{t("Choose all")}
			</StyledHeaderButton>
		</HeaderAction>
	);
};
